/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/111-bubble2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 3c-.858 0-1.687.135-2.464.402-.73.251-1.38.605-1.932 1.054C2.569 5.297 2 6.378 2 7.5c0 .63.175 1.24.52 1.815.356.592.89 1.134 1.547 1.566.474.312.793.812.878 1.373.028.187.046.376.053.564.117-.097.23-.201.342-.312a2 2 0 011.666-.57c.328.042.662.063.995.063.858 0 1.687-.135 2.464-.402a6.278 6.278 0 001.932-1.054c1.035-.841 1.604-1.922 1.604-3.044s-.57-2.203-1.604-3.044a6.299 6.299 0 00-1.932-1.054 7.563 7.563 0 00-2.464-.402zm0-2c4.418 0 8 2.91 8 6.5S12.418 14 8 14c-.424 0-.841-.027-1.247-.079-1.718 1.718-3.77 2.027-5.753 2.072v-.421c1.071-.525 2-1.48 2-2.572a3.01 3.01 0 00-.034-.448C1.157 11.36 0 9.54 0 7.5 0 3.91 3.582 1 8 1z"/>'
  }
})
